// extracted by mini-css-extract-plugin
module.exports = {"drawer":"SyllabusDrawer_drawer__XOuFs","closeButton":"SyllabusDrawer_closeButton__uv2Xz"};